import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id 55AE86E1-C6DB-4F41-BC21-1750DB608D23
 * name folder-zip-outline
 * version: 2.0.46
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/folder-zip-outline.svg
 * tags
 * - Files / Folders 
 */
export const FolderZipOutlineIcon = createSvgIcon(<><path d="M20 6H12L10 4H4C2.9 4 2 4.9 2 6V18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V8C22 6.9 21.1 6 20 6M20 18H16V16H14V18H4V8H14V10H16V8H20V18M16 12V10H18V12H16M14 12H16V14H14V12M18 16H16V14H18V16Z" /></>, 'FolderZipOutlineIcon');
export default FolderZipOutlineIcon